import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Main sections
import homeEs from "./locales/es/home.json";
import homePt from "./locales/pt/home.json";
import homeEn from "./locales/en/home.json";
import navbarEn from "./locales/en/navbar.json";
import footerEn from "./locales/en/footer.json";

import notFoundPageEs from "./locales/es/not-found-page.json";
import notFoundPagePt from "./locales/pt/not-found-page.json";
import notFoundPageEn from "./locales/en/not-found-page.json";
import navbarEs from "./locales/es/navbar.json";
import navbarPt from "./locales/pt/navbar.json";
import footerEs from "./locales/es/footer.json";
import footerPt from "./locales/pt/footer.json";
import esQuienesSomos from "./locales/es/quienessomos.json";
import ptQuienesSomos from "./locales/pt/quienessomos.json";
import enQuienesSomos from "./locales/en/quienessomos.json";
import faqEs from "./locales/es/faq.json";
import faqPt from "./locales/pt/faq.json";
import faqEn from "./locales/en/faq.json";
import contactoEs from "./locales/es/contacto.json";
import contactoPt from "./locales/pt/contacto.json";
import contactoEn from "./locales/en/contacto.json";
import tiendaEs from "./locales/es/tienda.json";
import tiendaPt from "./locales/pt/tienda.json";
import coursesEs from "./locales/es/courses.json";
import coursesPt from "./locales/pt/courses.json";
import coursesEn from "./locales/en/courses.json";

// Specific pages
import aprendePageEs from "./locales/es/aprende-page.json";
import aprendePagePt from "./locales/pt/aprende-page.json";
import postDetailPageEs from "./locales/es/postdetail-page.json";
import postDetailPagePt from "./locales/pt/postdetail-page.json";
import categoryPageEs from "./locales/es/category-page.json";
import categoryPagePt from "./locales/pt/category-page.json";
import courseDetailEs from "./locales/es/courseDetail.json";
import courseDetailPt from "./locales/pt/courseDetail.json";
import courseDetailEn from "./locales/en/courseDetail.json";

import homeHeroES from "./locales/es/homeHero.json";
import homeHeroEN from "./locales/en/homeHero.json";
import homeHeroPT from "./locales/pt/homeHero.json";

import studyShowcaseES from "./locales/es/studyShowcase.json";
import studyShowcaseEN from "./locales/en/studyShowcase.json";
import studyShowcasePT from "./locales/pt/studyShowcase.json";

import planShowcaseES from "./locales/es/planShowcase.json";
import planShowcaseEN from "./locales/en/planShowcase.json";
import planShowcasePT from "./locales/pt/planShowcase.json";

import learnShowcaseES from "./locales/es/learnShowcase.json";
import learnShowcaseEN from "./locales/en/learnShowcase.json";
import learnShowcasePT from "./locales/pt/learnShowcase.json";

import premiumBuddyShowcaseES from "./locales/es/premiumBuddyShowcase.json";
import premiumBuddyShowcaseEN from "./locales/en/premiumBuddyShowcase.json";
import premiumBuddyShowcasePT from "./locales/pt/premiumBuddyShowcase.json";

import whenZYShowcaseES from "./locales/es/whenZYShowcase.json";
import whenZYShowcaseEN from "./locales/en/whenZYShowcase.json";
import whenZYShowcasePT from "./locales/pt/whenZYShowcase.json";

import opportunityWorldShowcaseES from "./locales/es/opportunityWorldShowcase.json";
import opportunityWorldShowcaseEN from "./locales/en/opportunityWorldShowcase.json";
import opportunityWorldShowcasePT from "./locales/pt/opportunityWorldShowcase.json";

import studentChaosShowcaseES from "./locales/es/studentChaosShowcase.json";
import studentChaosShowcaseEN from "./locales/en/studentChaosShowcase.json";
import studentChaosShowcasePT from "./locales/pt/studentChaosShowcase.json";

import finalCTAES from "./locales/es/finalCTA.json";
import finalCTAEN from "./locales/en/finalCTA.json";
import finalCTAPT from "./locales/pt/finalCTA.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      es: {
        home: homeEs,
        homeHero: homeHeroES,
        studyShowcase: studyShowcaseES,
        planShowcase: planShowcaseES,
        learnShowcase: learnShowcaseES,
        premiumBuddyShowcase: premiumBuddyShowcaseES,
        whenZYShowcase: whenZYShowcaseES,
        opportunityWorldShowcase: opportunityWorldShowcaseES,
        studentChaosShowcase: studentChaosShowcaseES,
        finalCTA: finalCTAES,
        navbar: navbarEs,
        footer: footerEs,
        aprendePage: aprendePageEs,
        postDetailPage: postDetailPageEs,
        categoryPage: categoryPageEs,
        quienessomos: esQuienesSomos,
        faq: faqEs,
        contacto: contactoEs,
        tienda: tiendaEs,
        courses: coursesEs,
        courseDetail: courseDetailEs,
        notFoundPage: notFoundPageEs,
      },
      pt: {
        home: homePt,
        homeHero: homeHeroPT,
        studyShowcase: studyShowcasePT,
        planShowcase: planShowcasePT,
        learnShowcase: learnShowcasePT,
        premiumBuddyShowcase: premiumBuddyShowcasePT,
        whenZYShowcase: whenZYShowcasePT,
        opportunityWorldShowcase: opportunityWorldShowcasePT,
        studentChaosShowcase: studentChaosShowcasePT,
        finalCTA: finalCTAPT,
        navbar: navbarPt,
        footer: footerPt,
        aprendePage: aprendePagePt,
        postDetailPage: postDetailPagePt,
        categoryPage: categoryPagePt,
        quienessomos: ptQuienesSomos,
        faq: faqPt,
        contacto: contactoPt,
        tienda: tiendaPt,
        courses: coursesPt,
        courseDetail: courseDetailPt,
        notFoundPage: notFoundPagePt,
      },
      en: {
        home: homeEn,
        homeHero: homeHeroEN,
        studyShowcase: studyShowcaseEN,
        planShowcase: planShowcaseEN,
        learnShowcase: learnShowcaseEN,
        premiumBuddyShowcase: premiumBuddyShowcaseEN,
        whenZYShowcase: whenZYShowcaseEN,
        opportunityWorldShowcase: opportunityWorldShowcaseEN,
        studentChaosShowcase: studentChaosShowcaseEN,
        finalCTA: finalCTAEN,
        navbar: navbarEn,
        footer: footerEn,
        contacto: contactoEn,
        notFoundPage: notFoundPageEn,
        quienessomos: enQuienesSomos,
        faq: faqEn,
        courses: coursesEn,
        courseDetail: courseDetailEn,
      },
    },
    lng: "es",
    fallbackLng: "es",
    ns: [
      "home",
      "homeHero",
      "studyShowcase",
      "planShowcase",
      "learnShowcase",
      "premiumBuddyShowcase",
      "whenZYShowcase",
      "opportunityWorldShowcase",
      "studentChaosShowcase",
      "finalCTA",
      "navbar",
      "footer",
      "aprendePage",
      "postDetailPage",
      "categoryPage",
      "quienessomos",
      "faq",
      "contacto",
      "tienda",
      "courses",
      "courseDetail",
      "notFoundPage",
    ],
    defaultNS: "home",
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
    },
    interpolation: { escapeValue: false },
  });

export default i18n;
